/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.tyrechange,
            url: '/' + 'tyrechange',
            cache: false,
            title: 'Banden wissel',
            headerTitle: 'Banden wissel',
            configuratorStepName: ['TyreChangeStep'],
            order: 1,
            operations: [''],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/tyreChange.html',
                    controller: Controllers.TyreChangeController.controllerId + ' as vm'
                }
            },
            showInMenu: false
        }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }

    App.Core.appCore.run(appRun);
}